import { useRef, useState } from "react";

import {
  API, btn, C, DobSelect, dobIso, dobReady, fill, FONT, Header, label, openWhatsApp,
  PLAY_URL, sel, shareNodeAsImage, SITE, usePublicLang,
} from "./publicShared";

// Free, no-login Kundali (Guna) Milan — the wedding-season share page.
// Opened with /?page=milan; /?page=milan&s=<score> means someone shared theirs.
// Names stay in the browser (only on the share card); only the two birth
// dates go to the server, and nothing is stored.
//
// Trust rules (see memory: relationship status): the visitor may already be
// married. Never imply a wrong match, never scare. Dosha remedies from the
// API mention "before marriage", so they are NOT shown here — only a gentle
// note that doshas are often cancelled and an astrologer can check.

const KOOTAS = ["Varna", "Vashya", "Tara", "Yoni", "Graha Maitri", "Gana", "Bhakoot", "Nadi"];
const DOSHAS = ["Nadi Dosha", "Gana Dosha", "Bhakoot Dosha", "Kuja Dosha"];
const VERDICTS = ["Excellent", "Very Good", "Good", "Average", "Needs Remedies"];

const T = {
  en: {
    title: "Kundali Milan — check your Guna match",
    sub: "The traditional 36-guna (Ashtakoota) match from your two birth dates. Free, no sign-up, nothing is saved.",
    friend: "A couple you know scored {n} out of 36. Check yours!",
    p1: "Boy (groom)", p2: "Girl (bride)", nameOpt: "First name (optional)", dob: "Date of birth",
    timeOpt: "Time of birth (optional)", go: "Check our match", wait: "Matching the stars…",
    err: "Something went wrong. Please try again.",
    of36: "{n} of 36 gunas",
    verdict: ["Excellent", "Very good", "Good", "Average", "Needs care and remedies"],
    care: "Guna Milan is one part of a full match. It shows where to take care — it never says a marriage is wrong.",
    kootaTitle: "The 8 areas of the match",
    koota: ["Varna", "Vashya", "Tara", "Yoni", "Graha Maitri", "Gana", "Bhakoot", "Nadi"],
    kdesc: ["Values and outlook", "Mutual attraction and respect", "Birth-star harmony", "Nature and closeness",
      "Friendship of minds", "Temperament", "Emotional and family harmony", "Health and children"],
    dosha: ["Nadi Dosha", "Gana Dosha", "Bhakoot Dosha", "Kuja Dosha"],
    doshaNote: "{d} found. Doshas are often cancelled by other factors in the full chart, and remedies exist. An astrologer can check both full kundalis.",
    shareWa: "Share on WhatsApp", shareImg: "Share as image", copy: "Copy link", copied: "Link copied ✓",
    shareMsg: "💑 Our Kundali Milan: {n}/36 gunas — {v}\n\nCheck your Guna match free (1 minute):\n{u}",
    fullTitle: "Want the full picture?",
    fullText: "Your full reading shows both kundalis, Manglik status and what each area means for your life together.",
    fullBtn: "See full reading — free", app: "Get the Android app", again: "Check another match",
  },
  hi: {
    title: "कुंडली मिलान — अपना गुण मिलान देखें",
    sub: "दोनों की जन्म तिथि से पारंपरिक 36 गुण (अष्टकूट) मिलान। मुफ़्त, बिना साइन-अप, कुछ भी सेव नहीं होता।",
    friend: "आपके जान-पहचान के एक जोड़े के 36 में से {n} गुण मिले। आप भी देखें!",
    p1: "लड़का (वर)", p2: "लड़की (वधू)", nameOpt: "नाम (वैकल्पिक)", dob: "जन्म तिथि",
    timeOpt: "जन्म का समय (वैकल्पिक)", go: "हमारा मिलान देखें", wait: "सितारों का मिलान हो रहा है…",
    err: "कुछ गड़बड़ हुई। कृपया फिर से कोशिश करें।",
    of36: "36 में से {n} गुण",
    verdict: ["उत्तम", "बहुत अच्छा", "अच्छा", "सामान्य", "ध्यान और उपाय ज़रूरी"],
    care: "गुण मिलान पूरे मिलान का एक हिस्सा है। यह बताता है कि कहाँ ध्यान देना है — यह कभी नहीं कहता कि कोई विवाह गलत है।",
    kootaTitle: "मिलान के 8 पहलू",
    koota: ["वर्ण", "वश्य", "तारा", "योनि", "ग्रह मैत्री", "गण", "भकूट", "नाड़ी"],
    kdesc: ["मूल्य और सोच", "आपसी आकर्षण और सम्मान", "जन्म नक्षत्र का मेल", "स्वभाव और निकटता",
      "मन की मित्रता", "प्रकृति", "भावनात्मक और पारिवारिक मेल", "स्वास्थ्य और संतान"],
    dosha: ["नाड़ी दोष", "गण दोष", "भकूट दोष", "मंगल (कुज) दोष"],
    doshaNote: "{d} मिला। पूरी कुंडली के दूसरे योगों से दोष अक्सर रद्द हो जाते हैं, और उपाय भी हैं। ज्योतिषी दोनों की पूरी कुंडली देख सकते हैं।",
    shareWa: "WhatsApp पर भेजें", shareImg: "फ़ोटो के रूप में भेजें", copy: "लिंक कॉपी करें", copied: "लिंक कॉपी हो गया ✓",
    shareMsg: "💑 हमारा कुंडली मिलान: 36 में से {n} गुण — {v}\n\nअपना गुण मिलान मुफ़्त देखें (1 मिनट):\n{u}",
    fullTitle: "पूरी तस्वीर देखनी है?",
    fullText: "पूरी रीडिंग में दोनों की कुंडली, मांगलिक स्थिति और साथ के जीवन पर हर पहलू का असर है।",
    fullBtn: "पूरी रीडिंग देखें — मुफ़्त", app: "Android ऐप पाएँ", again: "दूसरा मिलान देखें",
  },
  te: {
    title: "కుండలి మిలన్ — మీ గుణ పొంతన చూడండి",
    sub: "ఇద్దరి పుట్టిన తేదీలతో సంప్రదాయ 36 గుణాల (అష్టకూట) పొంతన. ఉచితం, సైన్-అప్ లేదు, ఏదీ సేవ్ చేయము.",
    friend: "మీకు తెలిసిన ఒక జంటకు 36 లో {n} గుణాలు కుదిరాయి. మీదీ చూడండి!",
    p1: "అబ్బాయి (వరుడు)", p2: "అమ్మాయి (వధువు)", nameOpt: "పేరు (ఐచ్ఛికం)", dob: "పుట్టిన తేదీ",
    timeOpt: "పుట్టిన సమయం (ఐచ్ఛికం)", go: "మా పొంతన చూడండి", wait: "నక్షత్రాలను పోలుస్తున్నాం…",
    err: "ఏదో తప్పు జరిగింది. మళ్లీ ప్రయత్నించండి.",
    of36: "36 లో {n} గుణాలు",
    verdict: ["అత్యుత్తమం", "చాలా బాగుంది", "బాగుంది", "సాధారణం", "జాగ్రత్త, పరిహారాలు అవసరం"],
    care: "గుణ మిలన్ పూర్తి పొంతనలో ఒక భాగం మాత్రమే. ఎక్కడ జాగ్రత్త అవసరమో చూపిస్తుంది — ఏ వివాహమూ తప్పు అని ఎప్పుడూ చెప్పదు.",
    kootaTitle: "పొంతనలోని 8 అంశాలు",
    koota: ["వర్ణ", "వశ్య", "తార", "యోని", "గ్రహ మైత్రి", "గణ", "భకూట", "నాడి"],
    kdesc: ["విలువలు, ఆలోచనలు", "పరస్పర ఆకర్షణ, గౌరవం", "జన్మ నక్షత్ర పొంతన", "స్వభావం, సాన్నిహిత్యం",
      "మనసుల స్నేహం", "ప్రవృత్తి", "భావోద్వేగ, కుటుంబ సామరస్యం", "ఆరోగ్యం, సంతానం"],
    dosha: ["నాడీ దోషం", "గణ దోషం", "భకూట దోషం", "కుజ దోషం"],
    doshaNote: "{d} కనిపించింది. పూర్తి జాతకంలోని ఇతర అంశాల వల్ల దోషాలు తరచూ రద్దవుతాయి, పరిహారాలూ ఉన్నాయి. జ్యోతిష్కులు ఇద్దరి పూర్తి జాతకాలు చూడగలరు.",
    shareWa: "WhatsApp లో పంపండి", shareImg: "ఫోటోగా పంపండి", copy: "లింక్ కాపీ చేయండి", copied: "లింక్ కాపీ అయింది ✓",
    shareMsg: "💑 మా కుండలి మిలన్: 36 లో {n} గుణాలు — {v}\n\nమీ గుణ పొంతన ఉచితంగా చూడండి (1 నిమిషం):\n{u}",
    fullTitle: "పూర్తి వివరాలు కావాలా?",
    fullText: "పూర్తి రీడింగ్‌లో ఇద్దరి జాతకాలు, కుజ దోష స్థితి, కలిసి జీవితంపై ప్రతి అంశం ప్రభావం ఉంటాయి.",
    fullBtn: "పూర్తి రీడింగ్ చూడండి — ఉచితం", app: "Android యాప్ పొందండి", again: "మరో పొంతన చూడండి",
  },
  ta: {
    title: "ஜாதகப் பொருத்தம் — உங்கள் குணப் பொருத்தம்",
    sub: "இருவரின் பிறந்த தேதியிலிருந்து பாரம்பரிய 36 குண (அஷ்டகூட) பொருத்தம். இலவசம், பதிவு தேவையில்லை, எதுவும் சேமிக்கப்படாது.",
    friend: "உங்களுக்குத் தெரிந்த ஒரு ஜோடிக்கு 36 இல் {n} குணங்கள். உங்களுடையதைப் பாருங்கள்!",
    p1: "ஆண் (மணமகன்)", p2: "பெண் (மணமகள்)", nameOpt: "பெயர் (விருப்பம்)", dob: "பிறந்த தேதி",
    timeOpt: "பிறந்த நேரம் (விருப்பம்)", go: "எங்கள் பொருத்தம் பார்", wait: "நட்சத்திரங்களைப் பொருத்துகிறோம்…",
    err: "ஏதோ தவறு. மீண்டும் முயற்சிக்கவும்.",
    of36: "36 இல் {n} குணங்கள்",
    verdict: ["மிகச் சிறப்பு", "மிக நன்று", "நன்று", "சராசரி", "கவனமும் பரிகாரமும் தேவை"],
    care: "குணப் பொருத்தம் முழுப் பொருத்தத்தின் ஒரு பகுதி மட்டுமே. எங்கே கவனம் தேவை என்று காட்டும் — எந்தத் திருமணமும் தவறு என்று ஒருபோதும் சொல்லாது.",
    kootaTitle: "பொருத்தத்தின் 8 அம்சங்கள்",
    koota: ["வர்ணம்", "வச்யம்", "தாரை", "யோனி", "கிரக மைத்ரி", "கணம்", "பகூடம்", "நாடி"],
    kdesc: ["மதிப்புகளும் பார்வையும்", "பரஸ்பர ஈர்ப்பும் மரியாதையும்", "ஜென்ம நட்சத்திர இணக்கம்", "இயல்பும் நெருக்கமும்",
      "மனங்களின் நட்பு", "குணம்", "உணர்வு மற்றும் குடும்ப இணக்கம்", "ஆரோக்கியமும் குழந்தைகளும்"],
    dosha: ["நாடி தோஷம்", "கண தோஷம்", "பகூட தோஷம்", "செவ்வாய் தோஷம்"],
    doshaNote: "{d} உள்ளது. முழு ஜாதகத்தின் பிற அம்சங்களால் தோஷங்கள் பெரும்பாலும் நீங்கும், பரிகாரங்களும் உண்டு. ஜோதிடர் இருவரின் முழு ஜாதகத்தையும் பார்க்கலாம்.",
    shareWa: "WhatsApp-ல் பகிருங்கள்", shareImg: "படமாகப் பகிருங்கள்", copy: "இணைப்பை நகலெடு", copied: "இணைப்பு நகலெடுக்கப்பட்டது ✓",
    shareMsg: "💑 எங்கள் ஜாதகப் பொருத்தம்: 36 இல் {n} குணங்கள் — {v}\n\nஉங்கள் குணப் பொருத்தத்தை இலவசமாகப் பாருங்கள் (1 நிமிடம்):\n{u}",
    fullTitle: "முழு விவரம் வேண்டுமா?",
    fullText: "முழு வாசிப்பில் இருவரின் ஜாதகம், செவ்வாய் தோஷ நிலை, சேர்ந்த வாழ்வில் ஒவ்வொரு அம்சத்தின் பொருள் உள்ளன.",
    fullBtn: "முழு வாசிப்பைப் பார் — இலவசம்", app: "Android செயலியைப் பெறுங்கள்", again: "வேறு பொருத்தம் பார்",
  },
  kn: {
    title: "ಕುಂಡಲಿ ಮಿಲನ — ನಿಮ್ಮ ಗುಣ ಹೊಂದಾಣಿಕೆ",
    sub: "ಇಬ್ಬರ ಜನ್ಮ ದಿನಾಂಕದಿಂದ ಸಾಂಪ್ರದಾಯಿಕ 36 ಗುಣಗಳ (ಅಷ್ಟಕೂಟ) ಹೊಂದಾಣಿಕೆ. ಉಚಿತ, ಸೈನ್-ಅಪ್ ಬೇಡ, ಏನನ್ನೂ ಉಳಿಸುವುದಿಲ್ಲ.",
    friend: "ನಿಮಗೆ ಗೊತ್ತಿರುವ ಒಂದು ಜೋಡಿಗೆ 36 ರಲ್ಲಿ {n} ಗುಣಗಳು. ನಿಮ್ಮದನ್ನೂ ನೋಡಿ!",
    p1: "ಹುಡುಗ (ವರ)", p2: "ಹುಡುಗಿ (ವಧು)", nameOpt: "ಹೆಸರು (ಐಚ್ಛಿಕ)", dob: "ಜನ್ಮ ದಿನಾಂಕ",
    timeOpt: "ಜನ್ಮ ಸಮಯ (ಐಚ್ಛಿಕ)", go: "ನಮ್ಮ ಹೊಂದಾಣಿಕೆ ನೋಡಿ", wait: "ನಕ್ಷತ್ರಗಳನ್ನು ಹೊಂದಿಸುತ್ತಿದ್ದೇವೆ…",
    err: "ಏನೋ ತಪ್ಪಾಯಿತು. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    of36: "36 ರಲ್ಲಿ {n} ಗುಣಗಳು",
    verdict: ["ಅತ್ಯುತ್ತಮ", "ತುಂಬಾ ಚೆನ್ನಾಗಿದೆ", "ಚೆನ್ನಾಗಿದೆ", "ಸಾಧಾರಣ", "ಕಾಳಜಿ ಮತ್ತು ಪರಿಹಾರ ಬೇಕು"],
    care: "ಗುಣ ಮಿಲನ ಪೂರ್ಣ ಹೊಂದಾಣಿಕೆಯ ಒಂದು ಭಾಗ ಮಾತ್ರ. ಎಲ್ಲಿ ಕಾಳಜಿ ಬೇಕು ಎಂದು ತೋರಿಸುತ್ತದೆ — ಯಾವ ಮದುವೆಯೂ ತಪ್ಪು ಎಂದು ಎಂದಿಗೂ ಹೇಳುವುದಿಲ್ಲ.",
    kootaTitle: "ಹೊಂದಾಣಿಕೆಯ 8 ಅಂಶಗಳು",
    koota: ["ವರ್ಣ", "ವಶ್ಯ", "ತಾರಾ", "ಯೋನಿ", "ಗ್ರಹ ಮೈತ್ರಿ", "ಗಣ", "ಭಕೂಟ", "ನಾಡಿ"],
    kdesc: ["ಮೌಲ್ಯಗಳು ಮತ್ತು ದೃಷ್ಟಿಕೋನ", "ಪರಸ್ಪರ ಆಕರ್ಷಣೆ ಮತ್ತು ಗೌರವ", "ಜನ್ಮ ನಕ್ಷತ್ರ ಹೊಂದಾಣಿಕೆ", "ಸ್ವಭಾವ ಮತ್ತು ಆತ್ಮೀಯತೆ",
      "ಮನಸ್ಸುಗಳ ಸ್ನೇಹ", "ಪ್ರಕೃತಿ", "ಭಾವನಾತ್ಮಕ ಮತ್ತು ಕುಟುಂಬ ಸಾಮರಸ್ಯ", "ಆರೋಗ್ಯ ಮತ್ತು ಸಂತಾನ"],
    dosha: ["ನಾಡಿ ದೋಷ", "ಗಣ ದೋಷ", "ಭಕೂಟ ದೋಷ", "ಕುಜ ದೋಷ"],
    doshaNote: "{d} ಕಂಡುಬಂದಿದೆ. ಪೂರ್ಣ ಜಾತಕದ ಇತರ ಅಂಶಗಳಿಂದ ದೋಷಗಳು ಹೆಚ್ಚಾಗಿ ರದ್ದಾಗುತ್ತವೆ, ಪರಿಹಾರಗಳೂ ಇವೆ. ಜ್ಯೋತಿಷಿಗಳು ಇಬ್ಬರ ಪೂರ್ಣ ಜಾತಕ ನೋಡಬಹುದು.",
    shareWa: "WhatsApp ನಲ್ಲಿ ಹಂಚಿ", shareImg: "ಚಿತ್ರವಾಗಿ ಹಂಚಿ", copy: "ಲಿಂಕ್ ನಕಲಿಸಿ", copied: "ಲಿಂಕ್ ನಕಲಾಯಿತು ✓",
    shareMsg: "💑 ನಮ್ಮ ಕುಂಡಲಿ ಮಿಲನ: 36 ರಲ್ಲಿ {n} ಗುಣಗಳು — {v}\n\nನಿಮ್ಮ ಗುಣ ಹೊಂದಾಣಿಕೆ ಉಚಿತವಾಗಿ ನೋಡಿ (1 ನಿಮಿಷ):\n{u}",
    fullTitle: "ಪೂರ್ಣ ಚಿತ್ರಣ ಬೇಕೇ?",
    fullText: "ಪೂರ್ಣ ರೀಡಿಂಗ್‌ನಲ್ಲಿ ಇಬ್ಬರ ಜಾತಕ, ಕುಜ ದೋಷ ಸ್ಥಿತಿ ಮತ್ತು ಜೊತೆಗಿನ ಜೀವನಕ್ಕೆ ಪ್ರತಿ ಅಂಶದ ಅರ್ಥ ಇದೆ.",
    fullBtn: "ಪೂರ್ಣ ರೀಡಿಂಗ್ ನೋಡಿ — ಉಚಿತ", app: "Android ಆ್ಯಪ್ ಪಡೆಯಿರಿ", again: "ಬೇರೆ ಹೊಂದಾಣಿಕೆ ನೋಡಿ",
  },
  mr: {
    title: "कुंडली मिलन — तुमचे गुण मिलन पहा",
    sub: "दोघांच्या जन्मतारखेवरून पारंपरिक 36 गुण (अष्टकूट) मिलन. मोफत, साइन-अप नाही, काहीही सेव्ह होत नाही.",
    friend: "तुमच्या ओळखीच्या एका जोडप्याचे 36 पैकी {n} गुण जुळले. तुमचे पहा!",
    p1: "मुलगा (वर)", p2: "मुलगी (वधू)", nameOpt: "नाव (ऐच्छिक)", dob: "जन्मतारीख",
    timeOpt: "जन्माची वेळ (ऐच्छिक)", go: "आमचे मिलन पहा", wait: "ताऱ्यांचे मिलन होत आहे…",
    err: "काहीतरी चुकले. पुन्हा प्रयत्न करा.",
    of36: "36 पैकी {n} गुण",
    verdict: ["उत्तम", "खूप छान", "छान", "सामान्य", "काळजी व उपाय आवश्यक"],
    care: "गुण मिलन हा पूर्ण मिलनाचा एक भाग आहे. कुठे काळजी घ्यावी ते सांगतो — कोणताही विवाह चुकीचा आहे असे कधीच सांगत नाही.",
    kootaTitle: "मिलनाचे 8 पैलू",
    koota: ["वर्ण", "वश्य", "तारा", "योनी", "ग्रह मैत्री", "गण", "भकूट", "नाडी"],
    kdesc: ["मूल्ये आणि दृष्टिकोन", "परस्पर आकर्षण आणि आदर", "जन्म नक्षत्राचा मेळ", "स्वभाव आणि जवळीक",
      "मनांची मैत्री", "प्रकृती", "भावनिक आणि कौटुंबिक सलोखा", "आरोग्य आणि संतती"],
    dosha: ["नाडी दोष", "गण दोष", "भकूट दोष", "मंगळ दोष"],
    doshaNote: "{d} आढळला. पूर्ण कुंडलीतील इतर योगांमुळे दोष अनेकदा रद्द होतात, आणि उपायही आहेत. ज्योतिषी दोघांची पूर्ण कुंडली पाहू शकतात.",
    shareWa: "WhatsApp वर पाठवा", shareImg: "फोटो म्हणून पाठवा", copy: "लिंक कॉपी करा", copied: "लिंक कॉपी झाली ✓",
    shareMsg: "💑 आमचे कुंडली मिलन: 36 पैकी {n} गुण — {v}\n\nतुमचे गुण मिलन मोफत पहा (1 मिनिट):\n{u}",
    fullTitle: "पूर्ण चित्र हवे आहे?",
    fullText: "पूर्ण वाचनात दोघांची कुंडली, मांगलिक स्थिती आणि एकत्र जीवनावर प्रत्येक पैलूचा अर्थ आहे.",
    fullBtn: "पूर्ण वाचन पहा — मोफत", app: "Android ॲप मिळवा", again: "दुसरे मिलन पहा",
  },
};

const blank = { name: "", dob: { d: "", m: "", y: "" }, time: "" };

function Person({ t, lang, title, p, setP, idPrefix }) {
  return (
    <div style={{ display: "grid", gap: 12 }}>
      <div style={{ fontSize: 18, fontWeight: 800 }}>{title}</div>
      <div>
        <label htmlFor={`${idPrefix}-name`} style={label}>{t.nameOpt}</label>
        <input id={`${idPrefix}-name`} value={p.name} maxLength={20} onChange={(e) => setP({ ...p, name: e.target.value })}
          style={{ ...sel, width: "100%", boxSizing: "border-box", padding: "0 12px" }} />
      </div>
      <div>
        <span style={label}>{t.dob}</span>
        <DobSelect lang={lang} value={p.dob} onChange={(dob) => setP({ ...p, dob })} />
      </div>
      <div>
        <label htmlFor={`${idPrefix}-time`} style={label}>{t.timeOpt}</label>
        <input id={`${idPrefix}-time`} type="time" value={p.time} onChange={(e) => setP({ ...p, time: e.target.value })}
          style={{ ...sel, width: "100%", boxSizing: "border-box" }} />
      </div>
    </div>
  );
}

export default function MilanQuizPage({ onFullReading }) {
  const shared = Number(new URLSearchParams(window.location.search).get("s"));
  const [lang, setLang] = usePublicLang(T);
  const t = T[lang];
  const [p1, setP1] = useState(blank);
  const [p2, setP2] = useState(blank);
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(false);
  const [copied, setCopied] = useState(false);
  const cardRef = useRef(null);
  const resultRef = useRef(null);
  const ready = dobReady(p1.dob) && dobReady(p2.dob);

  async function check() {
    if (!ready) return;
    setLoading(true); setErr(false);
    try {
      const r = await fetch(`${API}/jyotish/milan`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dob1: dobIso(p1.dob), birth_time1: p1.time || "12:00",
          dob2: dobIso(p2.dob), birth_time2: p2.time || "12:00",
          boy: 1, // first form is the boy
        }),
      });
      const d = await r.json();
      if (!r.ok || d.error || typeof d.total !== "number") throw new Error();
      setRes(d);
      setTimeout(() => resultRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
    } catch { setErr(true); }
    setLoading(false);
  }

  const vIdx = res ? Math.max(0, VERDICTS.indexOf(res.verdict)) : 0;
  const verdict = res ? t.verdict[vIdx] : "";
  const names = [p1.name.trim(), p2.name.trim()].filter(Boolean);
  const shareUrl = res ? `${SITE}/?page=milan&s=${res.total}` : SITE;
  const shareText = res ? fill(t.shareMsg, { n: res.total, v: verdict, u: shareUrl }) : "";
  const doshas = (res?.doshas || []).map((d) => t.dosha[DOSHAS.indexOf(d.name)] || d.name);

  function copyLink() {
    navigator.clipboard?.writeText(shareText).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2500); });
  }

  return (
    <div style={{ minHeight: "100vh", background: C.bg, fontFamily: FONT, color: C.text }}>
      <div style={{ maxWidth: 520, margin: "0 auto", padding: "20px 16px 48px" }}>
        <Header lang={lang} setLang={setLang} />

        {shared > 0 && shared <= 36 && !res && (
          <div style={{ background: C.warm, border: `1.5px solid ${C.gold}`, borderRadius: 14, padding: "14px 16px", marginBottom: 18, fontSize: 17, fontWeight: 600, lineHeight: 1.5 }}>
            💑 {fill(t.friend, { n: shared })}
          </div>
        )}

        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(28px, 7.5vw, 38px)", lineHeight: 1.15, fontWeight: 700, margin: "0 0 12px" }}>{t.title}</h1>
        <p style={{ fontSize: 17, lineHeight: 1.6, color: C.dim, margin: "0 0 24px" }}>{t.sub}</p>

        <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 18, display: "grid", gap: 22, boxShadow: "0 2px 10px rgba(120,80,20,0.06)" }}>
          <Person t={t} lang={lang} title={t.p1} p={p1} setP={setP1} idPrefix="p1" />
          <div style={{ height: 1, background: C.border }} />
          <Person t={t} lang={lang} title={t.p2} p={p2} setP={setP2} idPrefix="p2" />
          <button onClick={check} disabled={!ready || loading} style={{ ...btn(C.accent), opacity: !ready || loading ? 0.55 : 1 }}>
            {loading ? t.wait : t.go}
          </button>
          {err && <div style={{ fontSize: 16, color: "#B42318" }}>{t.err}</div>}
        </div>

        {res && (
          <div ref={resultRef} style={{ marginTop: 28, display: "grid", gap: 16 }}>
            {/* Share card — captured as an image */}
            <div ref={cardRef} style={{ background: C.warm, border: `2px solid ${C.gold}`, borderRadius: 20, padding: "26px 22px", textAlign: "center" }}>
              <div style={{ fontSize: 44, lineHeight: 1 }}>💑</div>
              {names.length > 0 && (
                <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 28, fontWeight: 700, marginTop: 10, wordBreak: "break-word" }}>
                  {names.join(" ❤ ")}
                </div>
              )}
              <div style={{ fontSize: 64, fontWeight: 800, lineHeight: 1.1, marginTop: 10 }}>
                {res.total}<span style={{ fontSize: 28, color: C.dim, fontWeight: 700 }}> / 36</span>
              </div>
              <div style={{ fontSize: 17, color: C.dim }}>{fill(t.of36, { n: res.total })}</div>
              <div style={{ height: 12, background: C.card, border: `1px solid ${C.border}`, borderRadius: 6, overflow: "hidden", margin: "14px auto 0", maxWidth: 280 }}>
                <div style={{ width: `${Math.round((res.total / 36) * 100)}%`, height: "100%", background: C.accent }} />
              </div>
              <div style={{ fontSize: 24, fontWeight: 800, marginTop: 14 }}>{verdict}</div>
              <div style={{ fontSize: 15, color: C.accentDark, fontWeight: 700, marginTop: 16 }}>vedsanga.com</div>
            </div>

            <div style={{ background: C.card, border: `1.5px solid ${C.gold}`, borderRadius: 14, padding: 16, fontSize: 16, lineHeight: 1.6 }}>
              {t.care}
            </div>

            {doshas.length > 0 && (
              <div style={{ background: C.card, border: `1.5px solid ${C.accent}`, borderRadius: 14, padding: 16, fontSize: 16, lineHeight: 1.6 }}>
                {fill(t.doshaNote, { d: doshas.join(", ") })}
              </div>
            )}

            <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 18, display: "grid", gap: 14 }}>
              <div style={{ fontSize: 19, fontWeight: 800 }}>{t.kootaTitle}</div>
              {res.kootas.map((k) => {
                const i = KOOTAS.indexOf(k.name);
                return (
                  <div key={k.name} style={{ display: "grid", gap: 4 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 17 }}>
                      <b>{i >= 0 ? t.koota[i] : k.name}</b>
                      <span style={{ fontWeight: 700 }}>{k.score} / {k.max}</span>
                    </div>
                    <div style={{ fontSize: 15, color: C.dim }}>{i >= 0 ? t.kdesc[i] : k.desc}</div>
                    <div style={{ height: 8, background: C.warm, borderRadius: 4, overflow: "hidden" }}>
                      <div style={{ width: `${k.max ? Math.round((k.score / k.max) * 100) : 0}%`, height: "100%", background: C.accent }} />
                    </div>
                  </div>
                );
              })}
            </div>

            <button onClick={() => openWhatsApp(shareText)} style={btn(C.wa)}>{t.shareWa}</button>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={() => shareNodeAsImage(cardRef.current, `vedsanga-milan-${res.total}.png`, shareText)}
                style={{ ...btn(C.card, C.text), border: `1.5px solid ${C.border}` }}>{t.shareImg}</button>
              <button onClick={copyLink} style={{ ...btn(C.card, C.text), border: `1.5px solid ${C.border}` }}>{copied ? t.copied : t.copy}</button>
            </div>

            <div style={{ background: C.warm, border: `1.5px solid ${C.gold}`, borderRadius: 16, padding: 18, display: "grid", gap: 12, marginTop: 8 }}>
              <div style={{ fontSize: 21, fontWeight: 800 }}>{t.fullTitle}</div>
              <p style={{ fontSize: 17, lineHeight: 1.6, margin: 0, color: C.dim }}>{t.fullText}</p>
              <button onClick={onFullReading} style={btn(C.accent)}>{t.fullBtn}</button>
              {PLAY_URL && <a href={PLAY_URL} style={{ ...btn(C.card, C.text), border: `1.5px solid ${C.border}`, display: "flex", alignItems: "center", justifyContent: "center", textDecoration: "none", boxSizing: "border-box" }}>{t.app}</a>}
            </div>

            <button onClick={() => { setRes(null); window.scrollTo({ top: 0, behavior: "smooth" }); }} style={{ ...btn("transparent", C.accentDark), textDecoration: "underline" }}>{t.again}</button>
          </div>
        )}
      </div>
    </div>
  );
}
